import './App.css';
import { Routes, Route } from "react-router-dom"
import { PotentialBarrier } from './pages/potentialCalculationPage';

function App() {
  return (
    <>
    <Routes>
      <Route path='/' element={<PotentialBarrier/>}/>
    </Routes>
    </>
  );
}

export default App;
